import React, { useReducer, createContext } from 'react';
import type {
  OrgSearchState,
  OrgSearchAction,
  OrgSearchContextValue,
} from '../types';

const OrgSearchContext = createContext<OrgSearchContextValue>(undefined as any);

const initialState: OrgSearchState = {
  search: '',
  filters: {
    name: null,
    us_state: null,
    city: null,
    category: null,
  },
};

export const ACTIONS = {
  SET_FILTERS: 'SET_FILTERS' as const,
  SET_SEARCH: 'SET_SEARCH' as const,
  CLEAR_FILTERS: 'CLEAR_FILTERS' as const,
};

const reducer = (
  state: OrgSearchState = initialState,
  { type, value }: OrgSearchAction,
): OrgSearchState => {
  switch (type) {
    case ACTIONS.SET_FILTERS:
      return { ...state, filters: value };
    case ACTIONS.CLEAR_FILTERS:
      return { ...state, filters: initialState.filters };
    case ACTIONS.SET_SEARCH:
      return { ...state, search: value };
    default:
      return state;
  }
};

function OrgSearchProvider(props: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <OrgSearchContext.Provider value={value}>
      {props.children}
    </OrgSearchContext.Provider>
  );
}

export { OrgSearchContext, OrgSearchProvider };
